import { AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { IconDefinition } from '@fortawesome/fontawesome-common-types';
import { DropDownListComponent } from '@progress/kendo-angular-dropdowns';
import { Subject } from 'rxjs';
import { switchMap, take, takeUntil, tap } from 'rxjs/operators';
import { FontAwesomeEngineService } from '../../../services/icons/font-awesome-engine.service';

@Component({
   selector: 'samweb-icon-picker',
   templateUrl: './icon-picker.component.html',
   styleUrls: ['./icon-picker.component.scss'],
})
export class IconPickerComponent implements OnInit, AfterViewInit, OnDestroy {
   constructor(private iconSearchEngine: FontAwesomeEngineService) {}

   private destroy$ = new Subject();

   @ViewChild('dropdownlist', { static: true })
   protected dropdownlist: DropDownListComponent;

   @Input()
   public set value(iconValue: IconDefinition) {
      this.dropdownlist.value = iconValue;
   }

   @Output()
   public valueChanged: EventEmitter<IconDefinition> = new EventEmitter<IconDefinition>();

   public icons: IconDefinition[] = [];

   public virtual: any = {
      itemHeight: 28,
   };

   ngOnInit() {}

   ngAfterViewInit(): void {
      this.dropdownlist.filterChange
         .asObservable()
         .pipe(
            tap(() => (this.dropdownlist.loading = true)),
            switchMap((searchValue) => this.iconSearchEngine.filterIconsWithSearchValue(searchValue)),
            tap((result) => (this.dropdownlist.data = result)),
            tap(() => (this.dropdownlist.loading = false)),
            takeUntil(this.destroy$)
         )
         .subscribe();

      this.iconSearchEngine.icons$
         .pipe(
            take(1),
            tap((icons) => (this.dropdownlist.data = icons)),
            takeUntil(this.destroy$)
         )
         .subscribe();
      this.dropdownlist.valueChange.pipe(takeUntil(this.destroy$)).subscribe((x) => this.valueChanged.emit(x));
   }

   ngOnDestroy(): void {
      this.destroy$.next();
      this.destroy$.complete();
   }
}
